import React, { useCallback, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useFetchGraphGlobalsBalances, useSetGraphGlobalsBalances } from '../../api-hooks/graph/globals';

const PointsContext = React.createContext({});

export const usePoints = () => useContext(PointsContext);

const getIntegerOrUndefined = (value) => {
	if (value === undefined) return undefined;
	const integer = parseInt(value, 10);
	if (Number.isInteger(integer)) return integer;
	return undefined;
};

export const PointsProvider = ({ children }) => {
	const { data: balances } = useFetchGraphGlobalsBalances();
	const setBalances = useSetGraphGlobalsBalances();
	const balance = balances?.balance ?? 0;
	const chipBalance = balances?.chipBalance ?? 0;
	const balanceWithChips = balance + chipBalance;

	const handleEventBalanceChange = useCallback((change) => {
		setBalances((currentBalances) => ({
			...currentBalances,
			balance: getIntegerOrUndefined(change.balance) ?? currentBalances.balance,
			chipBalance: getIntegerOrUndefined(change.chipBalance) ?? currentBalances.chipBalance,
		}));
	}, [setBalances]);

	const contextValue = useMemo(() => ({
		balance,
		chipBalance,
		balanceWithChips,
		handleEventBalanceChange,
		setBalances,
	}), [
		balance,
		chipBalance,
		balanceWithChips,
		handleEventBalanceChange,
		setBalances,
	]);

	return (
		<PointsContext.Provider value={contextValue}>
			{children}
		</PointsContext.Provider>
	);
};

PointsProvider.propTypes = {
	children: PropTypes.node.isRequired,
};
